// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';

// Bootstrap //
// import './assets/bootstrap-lcp/css/bootstrap.css';
// import './assets/bootstrap-lcp/js/bootstrap.js';

import BootstrapVue from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Vuetify //
// Vue.use(Vuetify);
// import 'vuetify/dist/vuetify.min.css';

import PrettyCheckbox from 'pretty-checkbox-vue';

// Material Icons //
import './assets/material-icons-lcp.css';
import 'font-awesome/css/font-awesome.css';

// New IcoMoon Icons 2018 //
import './assets/icons.css';

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import VTooltip from 'v-tooltip';

// Font Awesome Icons //
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons';

import 'animate.css';

import moment from 'moment';

import Notifications from 'vue-notification'

// input component registration
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

import _ from 'lodash';
import store from './store/store';
import router from './router/router';
import App from './App';
// import Vuetify from 'vuetify';

Vue.config.productionTip = false;

Vue.use(Notifications)
Vue.use(BootstrapVue);
Vue.use(PrettyCheckbox);
// register globally
Vue.component('multiselect', Multiselect);

Vue.use(VTooltip);
Vue.component('icon', Icon);

Vue.prototype.$moment = moment;
Vue.use(_);

const requireComponent = require.context('@/components/common/uiInputs', false, /[\w-]\.vue$/);

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);

    const componentName = upperFirst(camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')));

    Vue.component(componentName, componentConfig.default || componentConfig);
});

// global mixins
Vue.mixin({
    computed: {
        pageView () {
            return this.$store.state.ui.pageView;
        },
        pageLoaded () {
            return this.$store.state.ui.pageState === 'loaded';
        },
        testMode () {
            return (
                this.$store.state.ui.pageView === 'tests'
				|| this.$store.state.ui.pageView === 'testTable'
				|| this.$store.state.ui.pageView === 'managers'
            );
        },
        themeColours () {
            return this.$store.state.ui.pageView !== 'tests' ? ['#032f5e', '#032f5e'] : ['#032f5e', '#032f5e'];
        },
    },
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
